export enum DatePeriodEnum {
  Last1Day,
  Last7Days,
  Last30Days,
  MonthToDate,
  YearToDate,
  Next7Days,
  Next30Days,
  Next60Days,
  PreviousYear,
  PreviousMonth,
}
